import { Injectable } from "@angular/core";
import { AuthHttp } from "angular2-jwt";
import { VerificationGame, GameSign, BaseBean } from "./melate-sign";
import { BaseService } from "../base.service";
import { Response } from "@angular/http";
import { Observable } from "rxjs/Rx";

@Injectable()
export class GameVerificationService extends BaseService {

    private verificationModel: VerificationGame = new VerificationGame();
    /*  private modelBaseSign: BaseBean = new BaseBean();
  
      get getModelBaseSign(): BaseBean{
          return this.modelBaseSign;
      }*/

    set setVerificationModel(model: VerificationGame) {
        this.verificationModel = model;
    }

    get getVerificationModel(): VerificationGame {
        return this.verificationModel;
    }

    constructor(private authHttp: AuthHttp) {
        super();
    }

    verifyGame(game: String, folio: String): Observable<VerificationGame> {
        return this.authHttp.get(this.urls.gameVerification + '/' + game + '/' + folio)
            .map(response => {
                console.log('se imprime el json de la respuesta :', response.json());
                this.verificationModel = response.json();
                //this.modelBaseSign = this.getVerificationModel;

                return response.json();;
            }).catch(err => this.handleErrorAsObservable(err));
    }

    verifySign(melateSign: GameSign): Observable<any> {
        //return this.authHttp.post()
        console.log(melateSign);
        return this.authHttp.post(this.urls.verify, melateSign).map(response => {
            return response.json();
        }).catch(err => this.handleErrorAsObservable(err));
    }

    verifyWinners(wagerReference: String): Observable<any> {
        return this.authHttp.get(this.urls.verifyWinner + '/' + wagerReference)
            .map(response => response.json())
            .catch(err => {
                let error = err.json();
                /*if (error.status === 402)
                    return Observable.throw(error);
                else */
                if (error.status === 404)
                    return Observable.throw(error);//return Observable.throw(err.status);
                else if (error.status === 422)
                    return Observable.throw(error);
                else
                    return this.handleErrorAsObservable(err)
            });


    }

    emptyForm() {
        this.setVerificationModel = null;
    }
}


// WEBPACK FOOTER //
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/src/app/core/verify/game-verification-service.ts